import React, { useEffect } from 'react';
import PageHeader from '../components/PageHeader';
import FAQSection from '../components/FAQSection';
import usePageMeta from '../hooks/usePageMeta';
import { faqs } from '../data/mock';

const FAQPage = () => {
  usePageMeta({
    title: 'FAQ — Spanking, OTK, Safe Words, Sessions & More',
    description: 'Answers to common questions about Seattle spanking sessions: OTK spankings, paddling, whipping, cane, hairbrush, safe words, pricing, discretion, and what to expect from RealOTK.',
    path: '/faq',
  });

  // Inject FAQPage JSON-LD for rich snippets
  useEffect(() => {
    const scriptId = 'faq-json-ld';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    });
    return () => {
      const s = document.getElementById(scriptId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div>
      <PageHeader
        eyebrow="Answers"
        title="Frequently Asked Questions"
        subtitle="Everything you might want to know before reaching out."
        image="https://images.unsplash.com/photo-1519337265831-281ec6cc8514?auto=format&fit=crop&w=3840"
      />
      <FAQSection />
    </div>
  );
};

export default FAQPage;
